import './Footer.scss'
import { styled } from '@mui/material';

const ThemedFooter = styled('footer')(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: theme.palette.background.default,
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: theme.palette.custom.border,
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    color: theme.palette.text.secondary,
    padding: "22px 27px",
    opacity: "50%",
  }));


const Footer = () => {

    const currentYear = new Date().getFullYear();
    return (
        <ThemedFooter className='footer-container'>
            <div>
                {currentYear} All Rights Reserved
            </div>
        </ThemedFooter>
    )
}


export default Footer